import "./ConstructorCard.style.css";

import { Dispatch, SetStateAction } from "react";
import { GameCardState } from "../../../utils/states/ConstructorPageStates/GameCardState";
import { GameCard } from "../../../components/special/GameCard/GameCard";
import { CardSettings } from "./CardSettings/CardSettings";

interface ConstructorCardProps {
  gameCardState: GameCardState;
  setGameCardState: Dispatch<SetStateAction<GameCardState>>;
}

export const ConstructorCard = ({
  gameCardState,
  setGameCardState,
}: ConstructorCardProps) => {
  return (
    <div className="constructor-card">
      <GameCard gameCard={gameCardState} />
      <CardSettings
        gameCardState={gameCardState}
        setGameCardState={setGameCardState}
      />
    </div>
  );
};
